<template>
  <div class="card-empty position-relative p-a-20">
    <img
      src="../../../assets/Card Gradient Inactive.svg"
      alt="Gradient"
      class="image-filler position-absolute h-100"
    />
    <div class="position-relative" style="z-index: 1">
      <div class="d-flex justify-content-between align-items-start">
        <p class="f-Overpass f-w-600 f-16 my-1">
          Anda belum memiliki saldo E-Pay
        </p>
      </div>
      <p class="f-Overpass f-w-400 f-12 my-0">
        Lakukan top up untuk menampilkan saldo E-Pay anda disini
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "emptyCard",
};
</script>

<style scoped>
.card-empty {
  width: -webkit-fill-available;
  height: 150px;
  border-radius: 16px;
  background: linear-gradient(
    150deg,
    #c8d0dd -3.8%,
    rgba(111, 114, 135, 0.76) 127.29%
  );
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  color: #212121;
  flex: 0 0 auto;
  scroll-snap-align: start;
  margin-right: 10px;
}

.image-filler {
  top: 0;
  right: 0;
  border-radius: 16px;
}
</style>
